import React, { useContext, useState } from 'react';
import HighlightedOffer from './offer/highlighted-offer';
import { HighlightedOfferPanel, HighlightWrapper } from './styles';
import { HighlightedOfferType, IHighlightedOffersProps } from './types';
import { AppContext } from '@prisjakt/ui-app-context';
import HighlightOfferExperiment from './experiment/experimentHighlightOffer';
import { Price } from 'src/types';
import { CurrentCampaign } from '../../types';

export const HighlightedOffers: React.FC<IHighlightedOffersProps> = props => {
  const [showHighlightedOffers, setShowHighlightedOffers] = useState(false);
  const { t } = useContext(AppContext);

  const highlightsExist = Boolean(
    props.highlights?.best ||
      props.highlights?.cheap ||
      props.highlights?.fastest
  );

  const showHighlightedOfferPanel = highlightsExist && showHighlightedOffers;
  const highlightCount = Object.keys(props.highlights).filter(
    h => props.highlights[h] !== null
  ).length;

  return (
    <>
      <HighlightOfferExperiment
        highlightsExist={highlightsExist}
        categoryId={props.categoryId}
        setShowHighlightedOffers={setShowHighlightedOffers}
      />
      {showHighlightedOfferPanel && (
        <HighlightWrapper>
          <HighlightedOfferPanel>
            {props.highlights?.best && (
              <HighlightedOffer
                title={t('product', 'price.recommended-description')}
                productId={props.productId}
                priceDisplay={props.priceDisplay}
                campaign={getCampaignById(
                  props.highlights.best,
                  props.campaign
                )}
                offer={props.highlights?.best}
                type={HighlightedOfferType.Recommended}
                highlightCount={highlightCount}
                media={props.media}
              />
            )}
            {props.highlights?.cheap && (
              <HighlightedOffer
                title={t('product', 'price.affordable')}
                productId={props.productId}
                priceDisplay={props.priceDisplay}
                campaign={getCampaignById(
                  props.highlights.cheap,
                  props.campaign
                )}
                offer={props.highlights?.cheap}
                type={HighlightedOfferType.Cheapest}
                highlightCount={highlightCount}
                media={props.media}
              />
            )}
          </HighlightedOfferPanel>
        </HighlightWrapper>
      )}
    </>
  );
};

const getCampaignById = (
  item: Price,
  campaign: CurrentCampaign | null | undefined
) => {
  return campaign?.price &&
    campaign?.media &&
    campaign?.name &&
    item.id === campaign.price.id
    ? campaign
    : null;
};
